import { ListAction, ListBranch, ListBranchItem } from '../types-store';
import { mapInitialSelection, mapActionsToSelection } from './map-selection';

export const mapCheckedValues = (
  listBranch: ListBranch[],
  listActions: ListAction[],
  initialValueSelected: (item: ListBranchItem) => boolean
) => {

  const initialSelection = mapInitialSelection(listBranch, initialValueSelected);

  const selectionAfterActions = mapActionsToSelection(initialSelection, listActions);

  return selectionAfterActions
    .reduce(
      (selection, item) => ({
        ...selection,
        [item.path[item.path.length - 1]]: item.selected
      }),
      {} as { [id: number]: boolean }
    );
};
